import { createAction } from "@reduxjs/toolkit";

export const resetAppState = createAction("RESET_APP_STATE");